"use strict";
(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/surveys"],{

/***/ "./src/assets/js/api-instance.js":
/*!***************************************!*\
  !*** ./src/assets/js/api-instance.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ApiService: () => (/* binding */ ApiService)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ApiService = /*#__PURE__*/function () {
  function ApiService() {
    _classCallCheck(this, ApiService);
    this.defaultHeaders = {
      'Content-Type': 'application/json'
    };
  }
  return _createClass(ApiService, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(endpoint) {
        var headers,
          url,
          response,
          data,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              headers = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.p = 1;
              url = "".concat(endpoint);
              _context.n = 2;
              return fetch(url, {
                method: 'GET',
                headers: _objectSpread(_objectSpread({}, this.defaultHeaders), headers)
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              throw new Error("GET ".concat(endpoint, " failed: ").concat(response.status, " ").concat(response.statusText));
            case 3:
              _context.n = 4;
              return response.json();
            case 4:
              data = _context.v;
              return _context.a(2, data);
            case 5:
              _context.p = 5;
              _t = _context.v;
              throw _t;
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 5]]);
      }));
      function get(_x) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(endpoint) {
        var body,
          headers,
          url,
          response,
          data,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              body = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              headers = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              _context2.p = 1;
              url = "".concat(endpoint);
              _context2.n = 2;
              return fetch(url, {
                method: 'POST',
                headers: _objectSpread(_objectSpread({}, this.defaultHeaders), headers),
                body: JSON.stringify(body)
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 3;
                break;
              }
              throw new Error("POST ".concat(endpoint, " failed: ").concat(response.status, " ").concat(response.statusText));
            case 3:
              _context2.n = 4;
              return response.json();
            case 4:
              data = _context2.v;
              return _context2.a(2, data);
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              throw _t2;
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5]]);
      }));
      function post(_x2) {
        return _post.apply(this, arguments);
      }
      return post;
    }()
  }]);
}();

/***/ }),

/***/ "./src/assets/js/surveys.js":
/*!**********************************!*\
  !*** ./src/assets/js/surveys.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _api_instance__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api-instance */ "./src/assets/js/api-instance.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var Surveys = /*#__PURE__*/function (_HTMLElement) {
  function Surveys() {
    var _this;
    _classCallCheck(this, Surveys);
    _this = _callSuper(this, Surveys);
    _this.api = new _api_instance__WEBPACK_IMPORTED_MODULE_0__.ApiService();
    _this.surveys = [];
    _this.activeSurveys = [];
    var popupElement = _this.querySelector("analytic-popup");
    _this.apiUrl = (popupElement === null || popupElement === void 0 ? void 0 : popupElement.getAttribute('data-surveys-api-url')) || '/apps/surveys-staging';
    _this.locale = (popupElement === null || popupElement === void 0 ? void 0 : popupElement.getAttribute('data-locale')) || "de";
    _this.feedbackYes = (popupElement === null || popupElement === void 0 ? void 0 : popupElement.getAttribute('data-feedbackYes')) || 'Yes';
    _this.feedbackNo = (popupElement === null || popupElement === void 0 ? void 0 : popupElement.getAttribute('data-feedbackNo')) || 'No';
    return _this;
  }
  _inherits(Surveys, _HTMLElement);
  return _createClass(Surveys, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.fetchActiveSurveys();
            case 1:
              this.initializePopup();
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              throw _t;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "fetchActiveSurveys",
    value: function () {
      var _fetchActiveSurveys = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var currentUrl, apiLanguage, queryParams, response, surveys, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.p = 0;
              currentUrl = this.removeLanguagePrefix(window.location.href);
              apiLanguage = this.locale === 'en' ? 'de' : this.locale;
              queryParams = new URLSearchParams({
                pageUrl: currentUrl,
                lang: apiLanguage
              });
              _context2.n = 1;
              return this.api.get("".concat(this.apiUrl, "/api/surveys?").concat(queryParams.toString()));
            case 1:
              response = _context2.v;
              surveys = response.data || [];
              if (surveys.length > 0) {
                this.selectedSurvey = this.selectPrioritySurvey(surveys, currentUrl);
                if (this.selectedSurvey) {
                  this.selectedSurvey = this.processSurveyForPopup(this.selectedSurvey);
                }
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('Error fetching surveys:', _t2);
              throw _t2;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function fetchActiveSurveys() {
        return _fetchActiveSurveys.apply(this, arguments);
      }
      return fetchActiveSurveys;
    }()
  }, {
    key: "removeLanguagePrefix",
    value: function removeLanguagePrefix(url) {
      var languagePrefixes = ['/en/, /pl/', '/fr/', '/de/'];
      for (var _i = 0, _languagePrefixes = languagePrefixes; _i < _languagePrefixes.length; _i++) {
        var prefix = _languagePrefixes[_i];
        if (url.includes(prefix)) {
          return url.replace(prefix, '/');
        }
      }
      return url;
    }
  }, {
    key: "selectPrioritySurvey",
    value: function selectPrioritySurvey(surveys, currentUrl) {
      var isMobile = this.isMobile();
      return surveys.find(function (survey) {
        if (!(isMobile ? survey.showMobile : survey.showDesktop)) return false;
        if (survey.targetScope === 'specific') {
          var _survey$targetPages;
          return (_survey$targetPages = survey.targetPages) === null || _survey$targetPages === void 0 ? void 0 : _survey$targetPages.some(function (page) {
            return currentUrl.includes(page.url) || page.url === '' || page.url === currentUrl;
          });
        }
        if (survey.targetScope === 'all') {
          // Check if current page is in excludePages array
          if (survey.excludePages && Array.isArray(survey.excludePages)) {
            var isExcluded = survey.excludePages.some(function (excludePage) {
              // Handle different possible structures of excludePage
              var pageUrl = excludePage.url || excludePage.pageUrl || excludePage;

              // Check if current URL matches any excluded page
              return currentUrl.includes(pageUrl) || pageUrl === currentUrl || pageUrl === '' && currentUrl === '/' || pageUrl === '/' && currentUrl === '';
            });

            // Only show survey if current page is NOT in excludePages array
            return !isExcluded;
          }

          // If no excludePages array, show on all pages
          return true;
        }
        return false;
      }) || null;
    }
  }, {
    key: "processSurveyForPopup",
    value: function processSurveyForPopup(survey) {
      var processedSurvey = {
        id: survey.id,
        name: survey.name,
        status: survey.status,
        displayMode: {
          mode: survey.displayMode,
          days: survey.displayDays
        },
        questions: this.processQuestions(survey.questions),
        thanks: this.processThanksMessage(survey.translations)
      };
      return processedSurvey;
    }
  }, {
    key: "processQuestions",
    value: function processQuestions(questions) {
      var _this2 = this;
      if (!questions || !questions.length) return [];
      var apiLanguage = this.currentLanguage;
      return questions.map(function (question) {
        var _question$translation, _question$translation2;
        var translation = (_question$translation = question.translations) === null || _question$translation === void 0 ? void 0 : _question$translation.find(function (t) {
          return t.language === apiLanguage;
        });
        var fallbackTranslation = translation || ((_question$translation2 = question.translations) === null || _question$translation2 === void 0 ? void 0 : _question$translation2[0]);
        var processedQuestion = {
          id: question.id,
          surveyId: question.surveyId,
          type: question.type,
          order: question.order,
          required: question.required,
          maxRating: question.maxRating,
          title: (fallbackTranslation === null || fallbackTranslation === void 0 ? void 0 : fallbackTranslation.title) || '',
          ctaLabel: (fallbackTranslation === null || fallbackTranslation === void 0 ? void 0 : fallbackTranslation.ctaLabel) || '',
          subheading: (fallbackTranslation === null || fallbackTranslation === void 0 ? void 0 : fallbackTranslation.subheading) || '',
          config: {}
        };
        if (question.type === 'rating' && fallbackTranslation) {
          processedQuestion.config.lowScoreLabel = fallbackTranslation.lowScoreLabel;
          processedQuestion.config.highScoreLabel = fallbackTranslation.highScoreLabel;
          processedQuestion.config.maxRating = question.maxRating;
        }
        var optionTypes = ['radio', 'checkbox', 'wants_feedback', 'feedback'];
        if (optionTypes.includes(question.type)) {
          if (fallbackTranslation !== null && fallbackTranslation !== void 0 && fallbackTranslation.answerOptions && fallbackTranslation.answerOptions.length > 0) {
            processedQuestion.config.options = fallbackTranslation.answerOptions.sort(function (a, b) {
              return a.order - b.order;
            }).map(function (option) {
              return {
                value: option.value,
                label: option.value
              };
            });
          } else if (question.type === 'wants_feedback' || question.type === 'feedback') {
            // Default options for feedback questions
            processedQuestion.config.options = [{
              value: 'true',
              label: _this2.feedbackYes
            }, {
              value: 'false',
              label: _this2.feedbackNo
            }];
          }
        }
        return processedQuestion;
      }).sort(function (a, b) {
        return a.order - b.order;
      });
    }
  }, {
    key: "processThanksMessage",
    value: function processThanksMessage(translations) {
      if (!translations || !translations.length) return null;
      var apiLanguage = this.currentLanguage;
      var translation = translations.find(function (t) {
        return t.language === apiLanguage;
      });
      if (!translation) {
        translation = translations[0];
      }
      if (!translation) return null;
      return {
        title: translation.thanksTitle,
        message: translation.thanksMessage
      };
    }
  }, {
    key: "initializePopup",
    value: function () {
      var _initializePopup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this3 = this;
        var popupElement;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (this.selectedSurvey) {
                _context4.n = 1;
                break;
              }
              console.log('No survey selected for display');
              return _context4.a(2);
            case 1:
              popupElement = this.querySelector('analytic-popup');
              if (!(popupElement && typeof popupElement.initWithSurvey === 'function')) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return popupElement.initWithSurvey(this.selectedSurvey);
            case 2:
              _context4.n = 4;
              break;
            case 3:
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      if (!(popupElement && popupElement.initWithSurvey)) {
                        _context3.n = 1;
                        break;
                      }
                      _context3.n = 1;
                      return popupElement.initWithSurvey(_this3.selectedSurvey);
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              })), 100);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function initializePopup() {
        return _initializePopup.apply(this, arguments);
      }
      return initializePopup;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      setTimeout(function () {
        _this4.init();
      }, 100);
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (customElements.get('surveys') === undefined) {
  customElements.define("surveys-component", Surveys);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/surveys.js"));
/******/ }
]);